type Props = {
  /** Уже отформатированная сумма: разделители расставляет useFormatAmount */
  amount: string;
  code: string;
};

/** Единая форма суммы с кодом актива: "70,75 RUB" */
export const buildAmountText = ({ amount, code }: Props): string => {
  return `${amount} ${code}`;
};
